import { Injectable } from '@angular/core';

@Injectable()
export class Constants {

    public options: Array<string> = ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua & Barbuda', 'Argentina',
        'Armenia', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium',
        'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia & Herzegovina', 'Botswana', 'Brazil', 'Brunei Darussalam',
        'Bulgaria', 'Burkina Faso', 'Myanmar/Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands',
        'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo', 'Costa Rica', 'Croatia', 'Cuba',
        'Cyprus', 'Czech Republic', 'Democratic Republic of the Congo', 'Denmark', 'Djibouti', 'Dominican Republic', 'Dominica',
        'Ecuador	', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Fiji', 'Finland', 'France',
        'French Guiana', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Great Britain', 'Greece', 'Grenada', 'Guadeloupe',
        'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hungary', 'Iceland', 'India', 'Indonesia',
        'Iran', 'Iraq', 'Israel and the Occupied Territories', 'Italy', 'Ivory Coast (Cote d Ivoire)', 'Jamaica', 'Japan',
        'Jordan', 'Kazakhstan', 'Kenya', 'Kosovo', 'Kuwait', 'Kyrgyz Republic (Kyrgyzstan)', 'Laos', 'Latvia', 'Lebanon', 'Lesotho',
        'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Republic of Macedonia', 'Madagascar', 'Malawi', 'Malaysia',
        'Maldives', 'Mali', 'Malta', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Moldova Republic of', 'Monaco',
        'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua',
        'Niger', 'Nigeria', 'Korea, Democratic Republic of (North Korea)', 'Norway', 'Oman', 'Pacific Islands', 'Pakistan', 'Panama',
        'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania',
        'Russian Federation', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent & Grenadines',
        'Samoa', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore',
        'Slovak Republic (Slovakia)', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'Korea, Republic of (South Korea)',
        'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Tajikistan',
        'Tanzania', 'Thailand', 'Timor Leste', 'Togo', 'Trinidad & Tobago', 'Tunisia', 'Turkey', 'Turkmenistan',
        'Turks & Caicos Islands', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United States of America (USA)', 'Uruguay',
        'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (UK)', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe'];

    public cities: Array<string> = [
        'Chennai',
        'Bangalore',
        'Mumbai',
        'New Delhi',
        'San Francisco',
        'Las Vegas',
        'Miami',
        'New York',
        'London',
        'Paris',
        'Berlin',
        'Rome',
        'Barcelona',
        'Madrid',
        'Cape Town',
        'Johannesburg',
        'Kuwait City',
        'Istanbul',
        'Dubai',
        'Bangkok',
        'Perth',
        'Beijing',
        'Shanghai',
        'Hong Kong',
        'Singapore',
        'Taipei',
        'Tokyo',
        'Brisbane',
        'Adelaide',
        'Sydney',
        'Melbourne'
    ];

    public EMAIL_REGEX: RegExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    public AboutSG1 = 'Trademarks are owned or controlled by Scientific Games Corporation ';
    public AboutSG2 = 'or one or more of its directly or indirectly wholly owned companies including Bally Gaming, Inc. ';
    public AboutSG3 = '(collectively, “Scientific Games”) or its licensors. Duplication of these programs in whole or in part ';
    public AboutSG4 = 'without written permission from the Legal Department of Scientific Games is expressly prohibited.';
    public Copyrights = '2019 Scientific Games Corporation. All rights reserved.';
    public CompanyName = 'Scientific Games Corporation';
    public CompanyAddress = '6650 S. El Camino Road, Las Vegas, NV 89118, USA';
    public Aboutus = 'About us';
    public Cancel = 'Cancel';
    public Change = 'Change';
    public ChangePassword = 'Change Password';
    public PasswordDesc = 'Passwords must be at least 8 characters and must include 1 special character and 1 number.';

}

